import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { LANGUAGES } from '../../constants';

export default ({ language, onLanguageChange }) => {
  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel id="language">Language</InputLabel>
      <Select
        labelId="language"
        value={language.id}
        onChange={(e) => onLanguageChange(LANGUAGES.find((lang) => lang.id === e.target.value))}
        label="Language"
      >
        {LANGUAGES.map((lang) => (
          <MenuItem key={lang.id} value={lang.id}>{lang.name}</MenuItem>
        ))}
      </Select>
      <FormHelperText>{' '}</FormHelperText>
    </FormControl>
  );
}